import React from 'react';
import { Text } from '../../typography';
import { getLabelColor } from '../buttonUtils';
import { Pressable } from './Pressable';

export type HeadlineButtonProps = {
  readonly onPress: () => void;
  readonly text: string;
};

export const HeadlineButton = ({ onPress, text }: HeadlineButtonProps) => {
  return (
    <Pressable onPress={onPress}>
      <Text
        color={getLabelColor({ type: 'tertiary' })}
        fontFamily="semibold"
      >
        {text}
      </Text>
    </Pressable>
  );
};
